import React, {useState} from 'react'
import {CheckCircleFilled} from '@ant-design/icons'
import moment from 'lib/localizedMoment'
import Card from 'components/shared/Card'
import Button from 'components/shared/Button'
import {getUnavailabilityReason} from './helpers'
import WeeklyAvailability from './WeeklyAvailability'
import TimeSlotPicker from './TimeSlotPicker'

const AvailableActions = ({resource, reservedBooking, selectedBooking, onRemove, onSelect}) => {
  const pendingBookings = resource.pendingBookings

  if (!pendingBookings.length) {
    return (
      <div>Ingen bookinger er tilgjengelig</div>
    )
  }

  const isBeingSelectedByResource = selectedBooking && pendingBookings.find(pb => pb.id === selectedBooking.id)
  const reservedBookingBelongsToResource = reservedBooking && pendingBookings.find(pb => pb.id === reservedBooking.id)
  
  return (
    <>
      {reservedBookingBelongsToResource ? (
        <>
        <div className="time-container">
          <div className="datetime selected">
            <CheckCircleFilled key="checked" />
            <span>{moment(reservedBooking.startsAt).calendar()}</span>
            <span>{moment(reservedBooking.startsAt).format('HH:mm')}</span>
          </div>
        </div>
        <div className="button-container">
          <Button loading={isBeingSelectedByResource} block onClick={onRemove}>Fjern</Button>
        </div>
          </>
        ) : (
          <>
            <div className="time-container">
              <span>{moment(resource.date).calendar()}</span>
            </div>
            <div className="button-container">
              <TimeSlotPicker 
                pendingBookings={pendingBookings}
                onSelect={onSelect}
                isBeingSelected={isBeingSelectedByResource}  
                disabled={isBeingSelectedByResource}
              />
            </div>
          </>
        )}
    </>
  )
}

const UnavailableActions = ({unavailabilityReason}) => {
  return (
    <div className="unavailability-reason">
      <p>Ressursen er ikke tilgjengelig for dette oppdraget.</p>
      <p>Grunn: {getUnavailabilityReason(unavailabilityReason)}</p>
    </div>
  )
}

const CardWithWeeklyAvailability = (props) => {
  return (
    <Card className="booking-availability-card">
      <Card.Content>
        <div className="card-header">
          {props.resource.serviceProvider.name}
          <div className="card-header-actions">
            <Button
              onClick={() => props.setShowAvailability(false)}
            >
              Lukk annen tilgjengelighet
            </Button>
          </div>
        </div>
        <WeeklyAvailability
          webOrder={props.webOrder}
          serviceProvider={props.resource.serviceProvider}
          reservedBooking={props.reservedBooking}
          selectedBooking={props.selectedBooking}
          onSelect={(booking) => {
            return props.onSelect(booking)
          }}
          onRemove={() => {
            return props.onRemove()
          }}
        />
      </Card.Content>
    </Card>
  )
}

const CardWithoutWeeklyAvailability = (props) => {
  const isAvailable = props.resource.isAvailable

  // No need to browse other availability if the resource is not capable
  const canChooseOtherAvailability = props.resource.unavailabilityReason !== 'not_capable'

  return (
    <Card className="booking-availability-card">
      <Card.Content>
        {props.resource.serviceProvider.name}
      </Card.Content>
      <Card.Actions>
        {isAvailable && (
          <AvailableActions
            {...props}
            onSelect={(pendingBooking) => {
              props.setShowAvailability(false)
              props.onSelect(pendingBooking)
            }}
          />
        )}
        {!isAvailable && (
          <UnavailableActions unavailabilityReason={props.resource.unavailabilityReason} />
        )}
        {canChooseOtherAvailability && (
          <Button
            block
            secondary
            type="action"
            onClick={() => props.setShowAvailability(true)}
          >
            Annen tilgjengelighet
          </Button>
        )}
      </Card.Actions>
    </Card>
  )
}

const BookingAvailability = (props) => {
  const [showAvailability, setShowAvailability] = useState(false)

  if (showAvailability) {
    return (
      <CardWithWeeklyAvailability
        {...props}
        setShowAvailability={setShowAvailability}
      />
    )
  }

  return (
    <CardWithoutWeeklyAvailability
      {...props}
      setShowAvailability={setShowAvailability}
    />
  )
}

export default BookingAvailability
